/**
 * Test IDs for the FCM Family Philanthropy Purpose Questionnaire (CUX-1841).
 * Used by Playwright and AI testing agents (Octomind) per Rule 20.
 *
 * Most form elements are rendered dynamically off the server's `question_code`,
 * so test IDs follow the pattern `fcm.q.<question_code>` (and
 * `fcm.q.<question_code>.<option_value>` for individual options).
 */
export const fcmTids = {
  intro: {
    soloRadio: 'fcm.intro.solo-radio',
    coupleRadio: 'fcm.intro.couple-radio',
    beginBtn: 'fcm.intro.begin-btn',
  },

  progress: {
    /** Step dot (dynamic). Append 0..4. */
    dotPrefix: 'fcm.progress.dot-',
  },

  modeToggle: {
    /** Mode button (dynamic). Append `${section}-${mode}`. */
    buttonPrefix: 'fcm.mode-toggle.button-',
  },

  /**
   * Dynamic question test ID.
   *   Single-value inputs (textarea, slider, madlib):  fcm.q.<question_code>
   *   Choice options (radio, checkbox, vehicle_card): fcm.q.<question_code>.<value>
   */
  questionPrefix: 'fcm.q.',

  interstitial: {
    generateBtn: 'fcm.interstitial.generate-btn',
    skipBtn: 'fcm.interstitial.skip-btn',
  },

  nav: {
    backBtn: 'fcm.nav.back-btn',
    nextBtn: 'fcm.nav.next-btn',
  },

  waiting: {
    backToDashboardBtn: 'fcm.waiting.back-to-dashboard-btn',
  },

  generating: {
    spinner: 'fcm.generating.spinner',
  },

  failed: {
    message: 'fcm.failed.message',
    retryBtn: 'fcm.failed.retry-btn',
  },

  result: {
    statementBlock: 'fcm.result.statement-block',
    pdfClientBtn: 'fcm.result.pdf-client-btn',
    pdfAdvisorBtn: 'fcm.result.pdf-advisor-btn',
    startOverBtn: 'fcm.result.start-over-btn',
  },
} as const;
